/* eslint-disable @typescript-eslint/no-use-before-define */
import React, {
	ReactElement,
	useState,
	useEffect,
	ChangeEvent,
	useCallback,
} from "react"
import { useFormik } from "formik"
import { Button, Box, Grid } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { BaseCFCStruct } from "../../../data/_config/shape"
import { initialValues } from "."
import { PanelsTitle } from "../../CFC"
import Spacer from "../../Spacer/Spacer"
import { routeVarReplacement, PrivateRoutes } from "../../../util/routes/routes"
import useCurrentClient from "../../../state/client/useCurrentClient"
import useStyles from "./__config/styles"
import DescriptiveNumberInput from "../../DescriptiveNumberInput"
import { SinglePicker } from "../../DateRange/__partials"
import { OpenState } from "../../DateRange/__config/shape"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import DateFnsUtils from "@date-io/date-fns"
import onCreate from "./onCreate"
import { useParams } from "react-router-dom"
import CFCUseCase from "../../../data/CFC/CFCLogic"

/**
 * Create canvas form.
 *
 * @export
 * @returns {ReactElement}
 */
export default function Step4Form({
	osveziMaster,
	values,
}: {
	osveziMaster: (values: any) => void
	values: any
}): ReactElement {
	const styles = useStyles()
	const { id: canvasId } = useParams<any>()

	const [useCustomTitle, setUseCustomTitle] = useState(false)
	const history = useHistory()
	const [currentClient] = useCurrentClient()

	const {
		setFieldValue,
		handleChange,
		// values,
		handleSubmit,
	} = useFormik<BaseCFCStruct>({
		initialValues,
		onSubmit: async (formValues: BaseCFCStruct) => {},
	})

	const onCiklogram = async () => {
		if (currentClient?.id) {
			values.step4Items = podaci
			values.canvasStartDate = startDate
			values.ukupnoTrajanje =
				(+pronadjiVrednostZaAktivnost(podaci, "Spoljno uređenje", "Kraj") - 1) /
				30

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line
			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStepCiklogram, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}

	const onPrev = async () => {
		if (currentClient?.id) {
			values.step4Items = rows
			values.canvasStartDate = startDate
			values.ukupnoTrajanje =
				(+pronadjiVrednostZaAktivnost(podaci, "Spoljno uređenje", "Kraj") - 1) /
				30

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line
			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep3, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}
	const onNext = async () => {
		if (currentClient?.id) {
			values.step4Items = rows
			values.canvasStartDate = startDate
			values.ukupnoTrajanje =
				(+pronadjiVrednostZaAktivnost(podaci, "Spoljno uređenje", "Kraj") - 1) /
				30

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line
			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep5, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}

	useEffect(() => {
		if (!useCustomTitle) {
			setFieldValue("canvasTitle", "")
		}
	}, [useCustomTitle, setFieldValue])

	// let startDate: Date
	let endDate: Date
	const [open, setOpen] = useState<OpenState>({ start: false, end: false })

	const {
		step1Items,
		step1CalculatedData,
		step2Items,
		step3Items,
		canvasStartDate,
	} = values

	const [startDate, setStartDate] = useState<Date>(
		canvasStartDate ? canvasStartDate : new Date()
	)

	const podzemnoSpratnost = step2Items ? step2Items.spratType : undefined
	const nadzemnoSpratnost =
		step1CalculatedData && step1CalculatedData[10]
			? step1CalculatedData[10][1]
			: undefined //6

	let podaci = step3Items

	function onOpen(key: keyof OpenState): void {
		setOpen({
			start: false,
			end: false,
			[key]: true,
		})
	}

	const openStart = useCallback(() => onOpen("start"), [])

	/**
	 * Closes the datepickers
	 *
	 */
	const onClose = useCallback((): void => {
		setOpen({
			start: false,
			end: false,
		})
	}, [])

	/**
	 * Triggers the passed in onChange method
	 *
	 * @param {(Date | null)} date
	 * @param {keyof OpenState} key
	 */
	const onDateChange = useCallback(
		(date: Date | null, key: keyof OpenState): void => {
			if (date) {
				setStartDate(date)
				calculateTrajanje(podaci, date)
				onClose()
			}
		},
		[onClose]
	)

	const pronadjiVrednostZaAktivnost = (podaci, nazivAktivnosti, atribut) => {
		// Prolazimo kroz sve ključeve u objektu podaci
		for (const kategorijaNaziv in podaci) {
			if (Object.hasOwnProperty.call(podaci, kategorijaNaziv)) {
				const kategorija = podaci[kategorijaNaziv]

				// Prolazimo kroz sve elemente u ovoj kategoriji
				for (let i = 0; i < kategorija.length; i++) {
					const element = kategorija[i]

					// Proverite da li je Naziv jednak nazivAktivnosti
					if (element.Naziv === nazivAktivnosti) {
						// Ako je Naziv jednak, vratite vrednost Trajanje iz tog elementa
						return element[atribut]
					}
				}
			}
		}

		// Ako aktivnost nije pronađena, možete vratiti neku podrazumevanu vrednost ili null
		return null
	}

	const calculateTrajanje = (podaci, date) => {
		// Iterirajte kroz sve elemente u objektu 'podaci'
		for (let kategorija in podaci) {
			let elementi = podaci[kategorija]
			for (let i = 0; i < elementi.length; i++) {
				let element = elementi[i]

				switch (element.Naziv) {
					case "Kupovina parcele":
						element.Trajanje2 = ""
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Upravljanje projektom":
						element.Trajanje2 = ""
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Projektovanje":
						element.Trajanje2 = ""
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Gradsko građevinsko zemljište, takse":
						element.Trajanje2 = ""
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Ostali radovi - rezerva":
						element.Trajanje2 = ""
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Šipovi":
						element.Trajanje2 = Math.ceil(element.MP / 3)
						element.Pocetak = 1
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 20
						break
					case "Zaštita temeljne jame sa iskopom i HI":
						element.Trajanje2 = Math.ceil(element.MP / 16)
						element.Pocetak =
							pronadjiVrednostZaAktivnost(podaci, "Šipovi", "Kraj") + 1
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 15
						break
					case "AB radovi - podzemno":
						element.Trajanje2 = Math.ceil(
							(10 +
								Math.ceil(
									element.MP / podzemnoSpratnost == 0
										? 1
										: podzemnoSpratnost / 30
								)) *
								podzemnoSpratnost
						)
						element.Pocetak =
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zaštita temeljne jame sa iskopom i HI",
								"Kraj"
							) + 1
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 20
						break
					case "AB radovi - nadzemno":
						element.Trajanje2 =
							Math.ceil(7 + Math.ceil(element.MP / nadzemnoSpratnost) / 30) *
							nadzemnoSpratnost

						element.Pocetak =
							pronadjiVrednostZaAktivnost(
								podaci,
								"AB radovi - podzemno",
								"Kraj"
							) + 1
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 15
						break
					case "Zidarski radovi - spoljni zidovi":
						element.Trajanje2 = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"AB radovi - nadzemno",
								"Trajanje2"
							) * 0.7
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"AB radovi - nadzemno",
								"Pocetak"
							) +
								(2 *
									pronadjiVrednostZaAktivnost(
										podaci,
										"AB radovi - nadzemno",
										"Trajanje2"
									)) /
									nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Zidarski radovi - unutrašnji zidovi":
						element.Trajanje2 = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"AB radovi - nadzemno",
								"Trajanje2"
							) *
								0.3 -
								1
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zidarski radovi - spoljni zidovi",
								"Kraj"
							) + 1
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Zidarski radovi - malterisanje":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)

						const masinskeInstalacije = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zidarski radovi - spoljni zidovi",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)

						element.Pocetak = Math.ceil(
							masinskeInstalacije + element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Zidarski radovi - košuljica":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zidarski radovi - malterisanje",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Krov sa termikom i olucima":
						element.Trajanje2 = 30

						const masinskeInstalacije2 = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zidarski radovi - spoljni zidovi",
								"Pocetak"
							) +
								pronadjiVrednostZaAktivnost(
									podaci,
									"AB radovi - nadzemno",
									"Trajanje2"
								) /
									nadzemnoSpratnost +
								pronadjiVrednostZaAktivnost(
									podaci,
									"AB radovi - nadzemno",
									"Trajanje2"
								)
						)

						element.Pocetak = Math.ceil(masinskeInstalacije2)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 5
						break
					case "Završni radovi - podzemno":
						element.Trajanje2 = 30

						const molerskoFarbarskiRadoviTrajanje = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)

						const zidarskiRadoviKošuljica = pronadjiVrednostZaAktivnost(
							podaci,
							"Zidarski radovi - košuljica",
							"Pocetak"
						)

						element.Pocetak = Math.ceil(
							molerskoFarbarskiRadoviTrajanje + zidarskiRadoviKošuljica
							// element.Trajanje2 / nadzemnoSpratnost
						)

						element.Kraj = element.Pocetak + element.Trajanje2 - 1

						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Molersko farbarski radovi",
								"Kraj"
							) + 1
						)

						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 10
						break
					case "VIK - instalacije":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zidarski radovi - spoljni zidovi",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Elektro - instalacije":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"VIK - instalacije",
								"Pocetak"
							)
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Mašinske - instalacije":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Elektro - instalacije",
								"Pocetak"
							)
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Mašinske - liftovi":
						element.Trajanje2 = 30
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Keramičarski radovi sa HI",
								"Pocetak"
							) + 1
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 5
						break
					case "Keramičarski radovi sa HI":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Zidarski radovi - košuljica",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Molersko farbarski radovi":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Keramičarski radovi sa HI",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Stolarski radovi - vrata":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Molersko farbarski radovi",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Parketarski radovi":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Stolarski radovi - vrata",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Bravarski radovi - stolarija":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Parketarski radovi",
								"Pocetak"
							) +
								element.Trajanje2 / nadzemnoSpratnost
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Bravarski radovi - ograde":
						element.Trajanje2 = 30
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Keramičarski radovi sa HI",
								"Pocetak"
							) + 1
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Suva gradnja":
						element.Trajanje2 = pronadjiVrednostZaAktivnost(
							podaci,
							"AB radovi - nadzemno",
							"Trajanje2"
						)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Molersko farbarski radovi",
								"Pocetak"
							)
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = ""
						break
					case "Fasaderski radovi":
						element.Trajanje2 = Math.ceil(element.MP / 25)
						element.Pocetak = element.Kraj - element.Trajanje2 + 1
						element.Kraj = Math.ceil(
							pronadjiVrednostZaAktivnost(
								podaci,
								"Bravarski radovi - stolarija",
								"Kraj"
							)
						)
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 20
						break
					case "Spoljno uređenje":
						element.Trajanje2 = Math.ceil(element.MP / 6)
						element.Pocetak = Math.ceil(
							pronadjiVrednostZaAktivnost(podaci, "Fasaderski radovi", "Kraj") +
								1
						)
						element.Kraj = element.Pocetak + element.Trajanje2 - 1
						element.PocetakDatumski = new Date(date)
						element.PocetakDatumski.setDate(
							date.getDate() + element.Pocetak - 1
						)
						element.KrajDatumski = new Date(date)
						element.KrajDatumski.setDate(date.getDate() + element.Kraj - 1)
						element.TrajanjeRealno = null
						element.IntervalTrajanje = 30
						break
					default:
						element.Trajanje2 = null
						break
				}
			}
		}
	}

	calculateTrajanje(podaci, startDate)

	// const [editedPodaci, setEditedPodaci] = useState(podaci)
	const [rows, setRows] = useState(podaci)

	useEffect(() => {
		values.ukupnoTrajanje =
			(+pronadjiVrednostZaAktivnost(podaci, "Spoljno uređenje", "Kraj") - 1) /
			30

		osveziMaster(values)
	}, [values])

	return (
		<>
			<Box className={styles.box}>
				{/* <Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onCiklogram}
				>
					Ciklogram
				</Button> */}
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onPrev}
				>
					Troškovi
				</Button>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onNext}
				>
					Prihodi
				</Button>
			</Box>
			<form onSubmit={handleSubmit} data-reactour="create-a-canvas">
				<PanelsTitle customTitle={"Dinamika"} useCustomTitle={true} />
				<Spacer />
				<Spacer />
				<Box
					className={styles.box}
					style={{
						width: "250px",
						marginLeft: "50%",
					}}
				>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<SinglePicker
							value={startDate}
							onChange={onDateChange}
							open={open.start}
							onOpen={openStart}
							onClose={onClose}
							label="Početak gradnje"
							compareDay={endDate}
							id="start"
						/>
					</MuiPickersUtilsProvider>
				</Box>
				<Spacer />
				<Box className={styles.box}>
					<Grid
						container
						spacing={1}
						// alignItems="center"
						justify="center"
						// alignContent="center"
					>
						<Grid xs={12}>
							<table>
								<thead>
									<tr>
										<th style={{ textAlign: "left" }}>Naziv</th>
										<th style={{ textAlign: "center" }}>Trajanje</th>
										<th style={{ textAlign: "center" }}>Početak</th>
										<th style={{ textAlign: "center" }}>Kraj</th>
										<th style={{ textAlign: "center" }}>Početak datumski</th>
										<th style={{ textAlign: "center" }}>Kraj datumski</th>
									</tr>
								</thead>
								<tbody>
									{Object.keys(rows).map((group, groupIndex) => (
										<React.Fragment key={groupIndex}>
											{group != "AKTIVNOSTI MIMO GRADNJE" ? (
												<tr>
													<th colSpan={1}>{group}</th>
												</tr>
											) : undefined}
											{group != "AKTIVNOSTI MIMO GRADNJE"
												? rows[group].map((item, itemIndex) => {
														return item.Trajanje2 ? (
															<tr key={itemIndex}>
																<td style={{ width: "350px" }}>{item.Naziv}</td>

																<td
																	style={{
																		width: "110px",
																		textAlign: "center",
																	}}
																>
																	{item.Trajanje2}
																</td>
																<td
																	style={{
																		width: "110px",
																		textAlign: "center",
																	}}
																>
																	{item.Pocetak}
																</td>
																<td
																	style={{
																		width: "110px",
																		textAlign: "center",
																	}}
																>
																	{item.Kraj}
																</td>
																<td
																	style={{
																		width: "150px",
																		textAlign: "center",
																	}}
																>
																	{item.PocetakDatumski
																		? item.PocetakDatumski.toLocaleDateString()
																		: undefined}
																</td>
																<td
																	style={{
																		width: "150px",
																		textAlign: "center",
																	}}
																>
																	{item.KrajDatumski
																		? item.KrajDatumski.toLocaleDateString()
																		: undefined}
																</td>
															</tr>
														) : undefined
												  })
												: undefined}
										</React.Fragment>
									))}
								</tbody>
							</table>
						</Grid>
					</Grid>
				</Box>
				<Spacer />
				<i>
					Trajanja uključuju vremenske rezerve jer su izjednačena sa najdužim
					tokom
				</i>
			</form>
		</>
	)
}
